const featureFlags = {
  STORAGE: import.meta.env.VITE__FF_STORAGE === 'true',
}

export default featureFlags;
